<template>
  <div>
    <div class="isShowActImg" @click="isShowHandle">
      {{isShowImg?'隐藏活动':'显示活动'}}
      <i class="act_icon" :class="isShowImg?'up_icon':'down_icon'"></i>
    </div>
    <div class="swiperList" v-show="isShowImg">
      <!-- <img :src="DomainUrl+'/Resource/License/small_汽配通活动banner_3.jpg'" alt="" @click="handleClick(1234)"> -->
      <img :src="DomainUrl + service.MallActivityManagementlist[0].ActivityBannerFigure" alt="" @click="handleClick(service.MallActivityManagementlist[0].Id)">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    service: Object,
  },
  data() {
    return {
      DomainUrl:'',
      isShowImg:true
    };
  },
  created(){
    this.DomainUrl = JSON.parse(localStorage.getItem('allinfo')).DomainUrl;
  },
  methods: {
    isShowHandle(){
      this.isShowImg = !this.isShowImg
    },
    handleClick(id){
      this.$emit("toActivityDetail", id)
    }
    
  },
};
</script>

<style lang="scss" scoped>
.swiperList{
  width: 100%;
  height: 3.22rem;
  overflow: hidden;
  img{
    width: 100%;
    vertical-align: top;
    object-fit: cover;
    height: 3.22rem;
  }
}
.isShowActImg{
  font-size: 0.24rem;
  background: #fff;
  width:1.6rem;
  padding: 5px 0;
  text-align: center;
  display: flex;
  background: #40AE47;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 5px;
  margin-bottom:5px;
  .act_icon{
    width:0.15rem;
    height: 0.16rem;
    display: block;
    margin-left: 0.1rem;
    &.up_icon{
      background: url(../assets/icon/up_icon.png) no-repeat;
      background-size:100% 100% 
    }
    &.down_icon{
      background: url(../assets/icon/down_icon.png) no-repeat;
      background-size:100% 100% 
    }
  }
}
</style>
